import businessOpportunity from './business-opportunity'
import commodity from './commodity'
import bank from './bank'
import taskCompletionTime from './task-completion-time'
export default {
  partnerAccept: {
    method: 'get',
    url: '/client/partner/accept',
    headers: {
      tokenInvite: ''
    }
  },
  'get-list': {
    method: 'post',
    url: '/client/partner/list'
  },
  'get-detail': {
    method: 'get',
    url: '/client/partner/ID'
  },
  'partner-add': {
    method: 'post',
    url: '/client/partner'
  },
  'partner-edit': {
    method: 'put',
    url: '/client/partner/ID'
  },
  'partner-delete': {
    method: 'delete',
    url: '/client/partner'
  },
  archive: {
    method: 'delete',
    url: '/client/partner/archive'
  },
  restore: {
    method: 'put',
    url: '/client/partner/restore'
  },
  find: {
    method: 'get',
    url: '/client/partner/find'
  },
  findContact: {
    method: 'get',
    url: '/client/partner/contact/COOPERATOR/find'
  },
  checkInvitation: {
    method: 'get',
    url: '/client/partner/check-invitation',
    headers: {
      tokenInvite: ''
    }
  },
  confirmStatusMarkup: {
    method: 'put',
    url: '/client/partner/confirm-status-markup/ID'
  },
  rejectStatusMarkup: {
    method: 'put',
    url: '/client/partner/reject-status-markup/ID'
  },
  customerStatus: {
    method: 'get',
    url: '/client/partner/customer-status/ID'
  },
  archiveDocument: {
    method: 'delete',
    url: '/client/partner/document/archive'
  },
  restoreDocument: {
    method: 'put',
    url: '/client/partner/document/restore'
  },
  archiveContact: {
    method: 'delete',
    url: '/client/partner/contact/archive'
  },
  restoreContact: {
    method: 'put',
    url: '/client/partner/contact/restore'
  },
  resendActivation: {
    method: 'post',
    url: '/client/partner/ID/resend-activation'
  },
  invites: {
    method: 'post',
    url: '/client/partner/invites'
  },
  businessOpportunity,
  commodity,
  bank,
  taskCompletionTime
}
